import React from 'react';
import Modal from 'scy/Modal';
import { formatContactNumber } from 'shared/utils';
import { LightBackground } from 'scy/Background';
import { linkText } from 'scy/utils.mod.scss';
import { AccentH5 } from 'scy/text';
import { accent } from 'scy/text/styles.mod.scss';
import Shaker from 'images/icons/shaker-filled.svg?react-svg';
import styles from './styles.mod.scss';
import margin from 'scy/margin.mod.scss';
import padding from 'scy/padding.mod.scss';

export default function ContactModal({ isOpen, handleClose, phoneNumber }) {
  const contactNumber = formatContactNumber(phoneNumber);
  const contactNumberHref = `tel:${contactNumber}`;

  return (
    <Modal isOpen={isOpen} handleClose={handleClose}>
      <LightBackground className={styles.background}>
        <div className={accent}>
          <Shaker width={28} height={40} />
        </div>
        <AccentH5 uppercase className={styles.heading}>
          Contact Us
        </AccentH5>
        <div className={margin.bottom_sm}>Call or text</div>
        <div className={`${padding.bottom_sm} ${margin.tablet_bottom_md}`}>
          <a href={contactNumberHref}>{contactNumber}</a>
        </div>
        <div className={`${margin.bottom_xs} ${margin.tablet_bottom_xxs}`}>
          Or send an email to:
        </div>
        <div>
          <a
            href="mailto:support@saucey.com"
            className={`${accent} ${linkText}`}
          >
            support@saucey.com
          </a>
        </div>
      </LightBackground>
    </Modal>
  );
}
